import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, offerHighlights, PRICE, PRODUCT } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precio" className="bg-electric" data-id="element-136" data-mp="1j9gu0ebk4t43">
      <div className="mx-auto max-w-page px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-137" data-mp="1nakbf5996x7f">
        <Reveal data-id="element-138" data-mp="1ncn3rvxvp2fb">
          <p className="text-[0.7rem] font-extrabold uppercase tracking-[0.26em] text-volt sm:text-sm" data-id="element-139" data-mp="1s9n9u6uqa56f">
            Oferta especial de lanzamiento
          </p>
          <h2 id="precio" className="mt-1 font-display text-xl uppercase leading-tight text-white sm:text-3xl lg:text-4xl" data-id="element-140" data-mp="1x9hxm1j7ien9">
            ⚡ {PRODUCT}
          </h2>
          <p className="mx-auto mt-1 max-w-2xl text-[0.75rem] font-extrabold uppercase leading-snug tracking-[0.1em] text-white/90 sm:text-sm" data-id="element-141" data-mp="2wa1m6jhvx01">
            De principiante a comprender los fundamentos de una instalación
            domiciliaria
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-4 max-w-2xl rounded-2xl border-2 border-volt bg-night p-4 sm:p-6" data-id="element-142" data-mp="1howvflgxy648">
          <p className="font-display text-lg uppercase text-volt sm:text-2xl" data-id="element-143" data-mp="1coimm17ims55">
            6 Tomos + 5 Bonos
          </p>

          <ul className="mt-3 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-144" data-mp="25g2cu52j56gn">
            {offerHighlights.map(item => <li key={item} className="flex items-center gap-2 rounded bg-carbon px-2.5 py-2 text-[0.78rem] font-bold uppercase text-white sm:text-[0.82rem]" data-id="element-145" data-mp="20g64jtmsusva">
                <CheckIcon size={14} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-146" data-mp="1repzm1er7iyg" />
                {item}
              </li>)}
          </ul>

          <p className="mt-4 rounded-lg bg-volt/15 px-3 py-2 text-[0.78rem] font-extrabold uppercase leading-snug text-volt sm:text-sm" data-id="element-147" data-mp="g2p3u2jh2u97">
            🎁 Más de {BONUS_VALUE} en bonos incluidos gratis
          </p>

          <p className="mt-3 text-[0.75rem] font-extrabold uppercase tracking-[0.18em] text-white sm:text-sm" data-id="element-148" data-mp="mei5tbyl1d4c">
            🔥 Precio especial de lanzamiento
          </p>
          <p className="mt-1 text-[0.7rem] font-bold uppercase tracking-[0.24em] text-steel sm:text-xs" data-id="element-149" data-mp="cgu0xt79ip8g">
            Hoy todo por solo:
          </p>
          <p className="font-display text-4xl leading-none text-volt sm:text-6xl" data-id="element-150" data-mp="3iidg01p07k8">
            ⚡ {PRICE} ⚡
          </p>
          <p className="mt-1 font-display text-base uppercase text-white sm:text-lg" data-id="element-151" data-mp="3kzjhc1x04zgl">
            Pago único
          </p>
          <p className="text-[0.7rem] font-semibold uppercase tracking-wide text-steel sm:text-xs" data-id="element-152" data-mp="3py30xvo4hz5s">
            Sin mensualidades • Acceso Digital
          </p>

          <div className="mt-4 flex flex-col items-center gap-2" data-id="element-153" data-mp="3fznbdx4quxye">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-154" data-mp="3g189fwq9oz10">
              🔥 OBTÉN EL SISTEMA COMPLETO HOY
            </CtaButton>
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-155" data-mp="2scs4mr5e0h1a">
              <ZapIcon size={18} className="mr-2 flex-shrink-0" strokeWidth={2.5} data-id="element-156" data-mp="2secw27wenjux" />
              ¡SÍ! QUIERO APRENDER ELECTRICIDAD DESDE CERO POR {PRICE}
            </CtaButton>
            <p className="flex items-center gap-1.5 text-[0.7rem] font-bold uppercase tracking-wide text-steel sm:text-xs" data-id="element-157" data-mp="3g960d7sxo8d3">
              <ShieldCheckIcon size={14} className="text-volt" data-id="element-158" data-mp="3bact3x48pdld" />
              Garantía de Devolución de 30 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}